<ion-app>
  <div class="impersonation-banner" *ngIf="authService.isImpersonating">
    Modo de Impersonación Activo<ng-container *ngIf="authService.impersonationRemainingLabel"> — {{ authService.impersonationRemainingLabel }}</ng-container>
  </div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
